import styles from "@/asserts/styles/formSection.module.less";
import { MaterialFileFormFields } from "@/components/commonFormItems/MaterialFileFormFields";
import ModalSectionHeader from "@/components/ui/ModalSectionHeader";
import { Col, Row } from "antd";
import { useFormEditable } from "../../hooks/useFormEditable";
import { useTranslation } from "react-i18next";

export const ApplicantSubmittedDocumentsFormFields = () => {
  const { t } = useTranslation("purchaseRequestManagement");
  const { isApplicantAddOrUpdateFilesFormFieldsForHighDisabled } =
    useFormEditable();

  return (
    <div className={styles.formSection}>
      <ModalSectionHeader title={t("申请人提供文件")} />

      <div className={styles.sectionBody}>
        <Row gutter={49}>
          <Col span={24}>
            <MaterialFileFormFields
              fieldName="meetingMinutes"
              label={t("采购委员会会议纪要文件")}
              isCustomDisabled={true}
              disabled={isApplicantAddOrUpdateFilesFormFieldsForHighDisabled}
              required
              hiddenRemove={
                isApplicantAddOrUpdateFilesFormFieldsForHighDisabled
              }
            />
          </Col>
          <Col span={24}>
            <MaterialFileFormFields
              fieldName="attachments"
              label={t("计划书URS配置清单第一次报价等文件")}
              isCustomDisabled={true}
              disabled={isApplicantAddOrUpdateFilesFormFieldsForHighDisabled}
              required
              hiddenRemove={
                isApplicantAddOrUpdateFilesFormFieldsForHighDisabled
              }
            />
          </Col>
          <Col span={24}>
            <MaterialFileFormFields
              fieldName="complianceAssessment"
              label={t("实地考察报告用户要求符合度评估文件")}
              required={false}
              isCustomDisabled={true}
              disabled={isApplicantAddOrUpdateFilesFormFieldsForHighDisabled}
              hiddenRemove={
                isApplicantAddOrUpdateFilesFormFieldsForHighDisabled
              }
            />
          </Col>
        </Row>
      </div>
    </div>
  );
};
